import { createAction, handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm } from 'redux-form';
import { api } from "api";
import { NotificationManager } from "react-notifications";
import moment from 'moment';

// ------------------------------------
// Constants
// ------------------------------------
const LOADER = 'LOADER_COMPRA';
const DATA = 'DATA_ORDEN';
const TAB_PARAMETERS = 'TAB_PARAMETERS';
const STATUS_YEAR_CHANGE = 'STATUS_YEAR_CHANGE';
// -----------------------------------
// Pure Actions
// -----------------------------------
const setLoader = loader => ({
    type: LOADER,
    loader,
});
const setData = data => ({
    type: DATA,
    data,
});

const setStatusYearChange = status_year_change => ({
    type: STATUS_YEAR_CHANGE,
    status_year_change,
});


// -----------------------------------
// Actions
// -----------------------------------

const getParameters = (params = {}) => (dispatch) => {
    dispatch(setLoader(true));
    api.get('parameters/get_production_finca', params).then((response) => {
        dispatch(setData(response));
        const data = {
            ...response,
            ...response.results
        };
        dispatch(initializeForm('ParametrosGenerales', data));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    });
};

const getStatusYearChange = (params = {}) => (dispatch) => {
    dispatch(setLoader(true));
    api.get('year_change/status', params).then((response) => {
        dispatch(setStatusYearChange(response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });                                                  
};


const updateParameters = (id, data,tab) => (dispatch) => {
    dispatch(setLoader(true));
    api.patch(`parameters/update_fields`, data).then((response) => {
        dispatch(getParameters({tab: tab }))
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
    }).catch((error) => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const yearChange = (data) => (dispatch) => {
    dispatch(setLoader(true));
    api.post(`year_change/activate_year_change`, data).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
        dispatch(getStatusYearChange())
    }).catch(() => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error en la edición', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const setSelectedYear = (year) => (dispatch) => {
    dispatch(setLoader(true));
    api.post(`year_change/set_year`, { year }).then((response) => {
        NotificationManager.success('Año cambiado exitosamente', 'Éxito', 3000);
        dispatch(getStatusYearChange());
    }).catch((error) => {
        NotificationManager.error((error && error.detail) ? error.detail : 'Error al cambiar el año', 'ERROR', 3000);
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const setTab = (tab) => (dispatch) => {
    dispatch(setLoader(true));
    if (tab === 'YEAR_CHANGE') {
        dispatch(getStatusYearChange());
        dispatch({ type: TAB_PARAMETERS, tab });
    } else {
        dispatch(getParameters({ tab }));
        dispatch({ type: TAB_PARAMETERS, tab });
    }

};
// get_production_finca

export const actions = {
    getParameters,
    updateParameters,
    setTab,
    getStatusYearChange,
    yearChange,
    setSelectedYear
};

// -----------------------------------
// Reducers
// -----------------------------------

const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [STATUS_YEAR_CHANGE]: (state, { status_year_change }) => {
        return {
            ...state,
            status_year_change,
        };
    },
    [TAB_PARAMETERS]: (state, { tab }) => {
        return {
            ...state,
            tab,
        };
    },

};

export const initialState = {
    loader: false,
    data: {
        results: [],
        count: 0,
    },
    status_year_change: {
        "current_year": undefined,
        "year": undefined,
        "is_active": undefined,
        "can_activate": undefined,
        "available_years": [],
        "message": ""
    },
    tab: 'PRODUCCION_FINCA',
};

export default handleActions(reducers, initialState)